module.exports = __webpack_public_path__ + "img/inclusive-gateway.aef68fe7.svg";